import { useCurrentSite } from '../providers/currentSite/useCurrentSite';
import { useUser } from '../providers/user/useUser';
import { showLoyaltyProgram } from '../services/showLoyaltyProgram';

export function useShowLoyaltyProgram() {
    const { currentSite } = useCurrentSite();
    const { user } = useUser();

    if (!user || typeof window === 'undefined') {
        return false;
    }

    return showLoyaltyProgram(user, currentSite.locale);
}
